import * as React from 'react';
import * as style from './style.css';
import { EInfrastructureType } from '../../../../containers/InfrastructureMapContainer';

interface IMapPinProps {
  type: EInfrastructureType;
  icon: React.ReactNode;
}

export const MapPin: React.FC<IMapPinProps> = ({ type, icon }) => {
  if (type === EInfrastructureType.Main) {
    return <div className={style['main-pin']}>{icon}</div>;
  }

  return <div className={style['pin']}>{icon}</div>;
};
